const dashboardData = async ({ token, userID, isAdmin }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/get_data?userId=${userID}&isAdmin=${isAdmin}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default dashboardData;
